import "./nextButton.css";

export const NewCircleButton = ({ position, onClick, slideIndex }) => {
  if ([1, 2, 3, 4, 5, 8].includes(slideIndex)) {
    return null;
  }

  return (
    <div
      className={`long-next-btn ${position}`}
      key={slideIndex}
      onClick={() => setTimeout(onClick, 500)}
    >
      <div className="custom-button-container">
        <button className="custom-button">
          <span className="custom-circle" aria-hidden="true">
            <span className="custom-icon custom-arrow"></span>
          </span>
          <span className="custom-text">Next</span>
        </button>
      </div>
    </div>
  );
};
